import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import useCommonMixin from '@/composables/useCommonMixin'
  import CookieHelper from '@/helpers/CookieHelper'
  import useAuthentication from '@/composables/useAuthentication'
  import { useRoute } from 'vue-router/composables'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthOperations',
  setup(__props) {

  const route = useRoute()
  const { inWebExtension } = useCommonMixin()
  const { tokenKey } = useAuthentication()
  const { translateString } = useI18n()

  const isLogin = computed(() => {
    return route.name === 'Login'
  })

  const isLoginCallback = computed(() => {
    return route.name === 'LoginCallback'
  })

  const isLogout = computed(() => {
    return route.name === 'Logout'
  })

  const redirect = computed(() => {
    return route.query.redirect ? `?redirect=${route.query.redirect}` : ''
  })

  const handleAuthOperations = async () => {
    if (isLogin.value) return handleLoginOperation()
    if (isLoginCallback.value) return handleLoginCallbackOperation()
    if (isLogout.value) {
      await UserModule.logout()
      let returnUrl = window.location.origin
      if (inWebExtension.value) returnUrl += '/chrome-extension'
      eventBus.$auth.logout({
        logoutParams: {
          returnTo: returnUrl,
        },
      })
    }
  }

  const handleLoginOperation = async () => {
    const token = CookieHelper.getCookieValue(tokenKey.value)
    if (token) {
      window.location.href = (route.query.redirect as string) || '/'
      return
    }

    await eventBus.$auth.loginWithRedirect({
      async openUrl(url = `${window.location.origin}/login/callback${redirect.value}`) {
        window.location.replace(url)
      },
    })
  }

  const handleLoginCallbackOperation = () => {
    if (route.query.error_description) {
      if (route.query.error === 'unauthorized') {
        eventBus.$toasted.error(translateString('onboarding.unauthorizedText'), { duration: 8000 })
      }
      if (route.query.error === 'access_denied') {
        eventBus.$toasted.error(translateString('onboarding.accessDeniedText'), { duration: 8000 })
      }
      const timeout = route.query.error ? 5000 : 2000
      setTimeout(() => (window.location.href = '/'), timeout)
      return
    }
  }

  handleAuthOperations()

return { __sfc: true,route, inWebExtension, tokenKey, translateString, isLogin, isLoginCallback, isLogout, redirect, handleAuthOperations, handleLoginOperation, handleLoginCallbackOperation, computed, UserModule, useCommonMixin, CookieHelper, useAuthentication, useRoute, eventBus, useI18n }
}

})